import React from 'react';

const GDPR_KEY = 'GDPR_ACCEPTED';

/**
 * Component that shows a cookie policy and manages the localstorage state of
 * the user that accepted the policy or not.
 */
class GDPR extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      accepted: false,
    }
  }

  componentDidMount() {
    const acceptedTerms = Boolean(localStorage.getItem(GDPR_KEY));
    if (acceptedTerms) {
      this.setState({ accepted: true});
    }
  }

  accept = () => {
    localStorage.setItem(GDPR_KEY, true);
      this.setState({ accepted: true});
  }

  render() {
    const { accepted } = this.state;
    return (
      <div style={{...styles.gdprPopup, ...(accepted ? { right: -350 } : {})}}>
        <span style={styles.close} onClick={() => this.accept()}>x</span>
        <span style={styles.message}>
          We use cookies, and by closing this message or using 
          this site you agree to our <span style={styles.terms} onClick={() => window.open('/terms', '_blank')}>terms & conditions</span>.
        </span>
        <button style={styles.button} onClick={() => this.accept()}>
          Accept
        </button>
      </div>
    )
  }
}

const styles = {
  gdprPopup: {
    position: 'fixed',
    bottom: 10,
    right: 10,
    width: 300,
    height: 110,
    backgroundColor: '#004DA9',
    borderRadius: 5,
    padding: 20,
    display: 'flex',
    justifyContent: 'center',
    transition: 'all 0.25s linear',
    zIndex: 10000,
  },
  message: {
    fontSize: 16,
    color: '#FFFFFF',
  },
  button: {
    backgroundColor: '#81d34c',
    borderColor: '#81d34c',
    height: 40,
    borderRadius: 5,
    width: 150,
    fontSize: 16,
    position: 'absolute',
    cursor: 'pointer',
    color: '#FFFFFF',
    bottom: 20,
  },
  close: {
    fontSize: 30,
    color: '#FFFFFF',
    position: 'absolute',
    top: 5,
    right: 15,
    cursor: 'pointer',
  },
  terms: {
    color: '#81d34c',
    cursor: 'pointer',
  }
};

export default GDPR;



// WEBPACK FOOTER //
// ./src/components/GDPR/GDPR.js